<template>
  <div class="cover" v-if="visible.closeFormula">
    <!-- <a-modal
      :title="title"
      :visible="visible.closeFormula"
      @ok="ok"
      @cancel="cancel" 
      destroyOnClose 
      :maskClosable="false"
      width="550px"
    >
      <template slot='footer'>
        <a-button @click="cancel">取消</a-button>
        <a-button @click="cancel">直接关闭</a-button>
        <a-button type="primary" @click="ok" :loading="saveLoding">我先保存数据</a-button>
      </template>
      <div style="font-size: 14px;">
        <span style="color: red;">关闭后，当前配方编辑数据将丢失，</span>
        <span style="color: #999;">你还要继续关闭吗？</span>
      </div>
    </a-modal> -->
    <div class="comfirmContent">
      <div>
        <div class="contentTitle">
          <a-icon type="info-circle" theme="filled" style="font-size: 25px;color: #faad14;" />
          <span style="margin-left: 10px;position: relative;top: -3px;font-size: 14px;font-weight: bold;">关闭配方</span>
        </div>
        <div style="font-size: 14px;padding-left: 35px;">
          <span style="color: #f04134;">关闭后，当前配方编辑数据将丢失，</span>
          <span style="color: #999;">你还要继续关闭吗？</span>
        </div>
      </div>
      <a-space class="footer">
        <a-button @click="cancel">取消</a-button>
        <a-button @click="goBack">直接关闭</a-button>
        <a-button type="primary" @click="ok">我先保存数据</a-button>
      </a-space>
    </div>
  </div>
</template>
<script>
import { nhfMixins } from '../../untils'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  mixins: [nhfMixins],
  data(){
    return {
      title: <p>关闭配方</p>,
      saveLoding: false
    }
  },
  methods:{
    async ok(){
      this.toggleVisible("saveModal");
      this.toggleVisible("closeFormula");
    },
    cancel(){
      this.toggleVisible("closeFormula");
    },
    async goBack() {
      let factoryId = window.localStorage.getItem('factoryId')
      let formulaId = getRequest("id")
      if(!factoryId || !formulaId) return
      await this.fetchPost({
        actions:this.clearTemp,
        showMessage: false,
        data: {
          factoryId,formulaId
        }
      })
      this.toggleVisible("closeFormula");
      this.$router.push("/nhf/compound-feed?name=配合饲料");
    },
  }
}
</script>
<style lang="scss" scoped>
.cover{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 1000000;
  .comfirmContent{
    width: 350px;
    height: 160px;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -175px;
    margin-top: -200px;
    background: #fff;
    border-radius: 5px;
  }
  .footer{
    position: absolute;
    bottom: 20px;
    right: 20px;
    & > div{
      float: right;
    }
  }
}
</style>